export enum PaymentPlatformEnum {
  COIN_BASE = "COIN_BASE",
  COIN_PAYMENT = "COIN_PAYMENT",
}
